import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import UserService from "../../Api/Services/UserService";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, socialLogin } from "../../store/actions";

// import images
import profile from "assets/images/logo-light.png";
import logo from "assets/images/logo.svg";

const Login = props => {
  //meta title
  document.title = "Login | infuseone ";
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  const InfuseoneUserToken = localStorage.getItem("InfuseoneUserToken");
  const [validationErrors, setValidationErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userData = {
      email: e.target.email.value,
      password: e.target.password.value,
      device_name: "web"
    };

    try {
      const response = await UserService.login(userData).json();

      if (response.status === true) {
        const usertoken = response.token;
        const rolename = response.rolename;
        const userinfo = response.user;

        localStorage.setItem("InfuseoneUserToken", usertoken);
        localStorage.setItem("Infuseonerolename", rolename);
        localStorage.setItem("Infuseoneuserinfo", JSON.stringify(userinfo));
        navigate("/dashboard");

      } else {

        setValidationErrors(response);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        setValidationErrors('Login Failed');
      } else {
        setValidationErrors('Login failed');
      }
    }
  };

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden commonboxform">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Sign in to continue to infuseone.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="logo-light-element">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form method="POST" onSubmit={handleSubmit}
                      className="form-horizontal"
                    >

                      {!validationErrors.errors && validationErrors.message && (
                        <Alert color="danger" style={{ display: "block" }}>{validationErrors.message}</Alert>
                      )}

                      <div className="mb-3">
                        <Label className="form-label">Username or email <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter Username or email"
                          type="text"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {validationErrors.errors && validationErrors.errors.email && (
                          <FormFeedback type="invalid" style={{ display: "block" }}>{validationErrors.errors.email}</FormFeedback>
                        )}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                        <Input
                          name="password"
                          type="password"
                          placeholder="Enter Password"
                          value={formData.password}
                          onChange={handleChange}
                        />
                        {validationErrors.errors && validationErrors.errors.password && (
                          <FormFeedback type="invalid" style={{ display: "block" }}>{validationErrors.errors.password}</FormFeedback>
                        )}
                      </div>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-secondary btn-block"
                          type="submit"
                        >
                          Sign in
                        </button>
                      </div>
                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                      <div className="mt-2 text-center">
                        <p>
                          Don&#39;t have an account ?{" "} <Link to="/register" className="fw-medium text-primary">
                            {" "}
                            Signup now{" "}
                          </Link>{" "}
                        </p>
                        {/* <p>
                  © {new Date().getFullYear()} infuseone. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by infuseone
                </p> */}
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
